module.exports = __webpack_public_path__ + "static/media/arrow-copie-11.96d5e7a5.svg";